<div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom">
  <h5 class="my-0 me-md-auto fw-normal">
    <a routerLink="/" class="text-dark" class="logo"></a>
  </h5>
  <nav class="my-2 my-md-0 me-md-3">
    <a
      class="p-2 text-dark"
      href="https://jss.sitecore.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'Documentation' | translate }}
    </a>
    <a routerLink="/styleguide" class="p-2 text-dark">
      {{ 'Styleguide' | translate }}
    </a>
    <a routerLink="/graphql" class="p-2 text-dark">
      {{ 'GraphQL' | translate }}
    </a>
  </nav>
</div>
